import axios, { AxiosError } from "axios";

import ApiHelper from "src/utils/ApiHelper";

import { ApiHeaderKeys } from "src/constants";

class ApiError extends Error {
  cause: string;
  statusCode?: number;
  requestId?: string;

  constructor(cause: string, statusCode?: number, requestId?: string) {
    super(cause);
    this.name = "ApiError";
    this.cause = cause;
    this.statusCode = statusCode;
    this.requestId = requestId;
  }
}

const baseURL = import.meta.env.VITE_API_BASE_URL;
const environment = import.meta.env.VITE_APP_ENVIRONMENT || "development";

if (import.meta.env.DEV) {
  console.log(`🔧 Environment: ${environment}`);
  console.log(`🌐 API Base URL: ${baseURL}`);
}

const headers = {
  [ApiHeaderKeys.ACCEPT_KEY]: ApiHeaderKeys.ACCEPT_VALUE,
  [ApiHeaderKeys.CONTENT_TYPE_KEY]: ApiHeaderKeys.CONTENT_TYPE_VALUE,
};

const api = axios.create({
  baseURL,
  headers,
  timeout: 1000 * 30, // 30 seconds
  validateStatus: (status: number) => ApiHelper.validateStatus(status),
});

const handleError = (error: AxiosError) => {
  const handledError = ApiHelper.handleError(error);
  throw new ApiError(
    handledError.cause.toString(),
    handledError.statusCode,
    handledError.requestId,
  );
};

api.interceptors.request.use(ApiHelper.interceptorRequest, handleError);
api.interceptors.response.use(ApiHelper.interceptorResponse, handleError);

export default api;
